"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($, common) {
        var localeChanged = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return common.locale.localeChanged(e, "#TemplateContainer");

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function localeChanged(_x3) {
                return _ref2.apply(this, arguments);
            };
        }();

        var initialise, registerHandlers, displayApplicationInformation, errorHandler, centreSelected, candidateSelected, acknowledgeMessage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        acknowledgeMessage = function acknowledgeMessage() {
                            var view = common.view.getFromCache("home");

                            common.display.render(view, "#TemplateContainer");
                        };

                        candidateSelected = function candidateSelected() {
                            window.location.href = "/Candidate/Login";
                        };

                        centreSelected = function centreSelected() {
                            window.location.href = "/Invigilator/Login";
                        };

                        errorHandler = function errorHandler(error) {
                            var errorResource = common.error.getErrorFromResource(error.errorCode);

                            var view = common.views.getErrorView(errorResource);

                            common.display.render(view, "#TemplateContainer");
                            //common.error.logSentryInfo("Home Error Handle", "Home Error", error);
                        };

                        displayApplicationInformation = function displayApplicationInformation(application) {
                            var messages = application.messages;

                            application.languages = common.locale.getLocales();

                            var view = common.view.getFromTemplate("home", application, true);

                            if (messages.length) {
                                common.view.addToCache("home", view);

                                view = common.view.getFromTemplate("messages", application);
                            }

                            common.display.render(view, "#TemplateContainer");

                            common.locale.selectCurrentLocale();
                        };

                        registerHandlers = function registerHandlers() {
                            var $document = $(document);
                            var $templateContainer = $("#TemplateContainer");

                            $document.on("touchmove", false);
                            $document.on("contextmenu", false);

                            $templateContainer.on("click", "#Centre", centreSelected);
                            $templateContainer.on("click", "#Candidate", candidateSelected);
                            $templateContainer.on("change", "#Languages", localeChanged);
                            $templateContainer.on("click", "#AcknowledgeMessage", acknowledgeMessage);
                        };

                        initialise = function initialise() {

                            registerHandlers();

                            common.system.checkBrowserSupported();

                            common.http.get("system").then(displayApplicationInformation).catch(errorHandler);
                        };

                        _context2.next = 9;
                        return common.locale.checkLocale("home");

                    case 9:

                        $(document).ready(initialise);

                    case 10:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function (_x, _x2) {
        return _ref.apply(this, arguments);
    };
})()(window.jQuery, window.common);